import { IUser } from "@/lib/database/schema/user";
import { ESubscriptionPlan } from "@/src/constants/enums";

type Feature =
  | 'viewHiringTeamEmails'
  | 'viewJobSalary'
  | 'trackApplications'
  | 'profilePreferences'
  | 'analyzeLinkedInProfile'
  | 'analyzeRecruiterLense'
  | 'generateTargetedCV'
  | 'analyzeJob';

export const FEATURE_ACCESS_MAP: Record<Feature, ESubscriptionPlan[]> = {
  analyzeJob: [ESubscriptionPlan.FREE, ESubscriptionPlan.STARTER, ESubscriptionPlan.PROFESSIONAL, ESubscriptionPlan.EXECUTIVE],
  viewHiringTeamEmails: [ESubscriptionPlan.STARTER, ESubscriptionPlan.PROFESSIONAL, ESubscriptionPlan.EXECUTIVE],
  viewJobSalary: [ESubscriptionPlan.STARTER, ESubscriptionPlan.PROFESSIONAL, ESubscriptionPlan.EXECUTIVE],
  trackApplications: [ESubscriptionPlan.STARTER, ESubscriptionPlan.PROFESSIONAL, ESubscriptionPlan.EXECUTIVE],
  profilePreferences: [ESubscriptionPlan.STARTER, ESubscriptionPlan.PROFESSIONAL, ESubscriptionPlan.EXECUTIVE],
  analyzeLinkedInProfile: [ESubscriptionPlan.FREE, ESubscriptionPlan.STARTER, ESubscriptionPlan.PROFESSIONAL, ESubscriptionPlan.EXECUTIVE],
  analyzeRecruiterLense: [ESubscriptionPlan.FREE, ESubscriptionPlan.STARTER, ESubscriptionPlan.PROFESSIONAL, ESubscriptionPlan.EXECUTIVE],
  generateTargetedCV: [ESubscriptionPlan.FREE, ESubscriptionPlan.STARTER, ESubscriptionPlan.PROFESSIONAL, ESubscriptionPlan.EXECUTIVE],
};